// extracted by mini-css-extract-plugin
export default {"link":"UserLinkField_link__YnZwK"};